var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-prestige-info-blocks"},[_c('HeaderEternityContainer',{staticClass:"l-game-header__eternity"}),_c('HeaderCenterContainer',{staticClass:"l-game-header__center"}),_c('HeaderInfinityContainer',{staticClass:"l-game-header__infinity"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }